import { finectAPI } from '@finect/front-utils/finectAPI';
export var fetchPerformance = function fetchPerformance(product) {
  return finectAPI({
    version: 'v4',
    path: "products/collectives/funds/".concat(product.id, "?expand=stats/performance"),
    method: 'GET',
    onSuccess: function onSuccess(_ref) {
      var data = _ref.data;
      return data.stats.performance;
    }
  });
};